export default __webpack_public_path__ + "static/media/Saly-6.2e82ab77.webp";